import React, { useEffect, useState } from 'react';
import "./CartItem.css";
import { useNavigate } from "react-router-dom";
import { useCartStore } from "../../stores/useCartStores";
import { useUserStore } from "../../stores/useUserStores";
import remove_icon from "../Assets/cart_cross_icon.png";

const CartItems = () => {
    const navigate = useNavigate();
    const { cartItems, getCartProducts, removeFromCart, updateQuantity } = useCartStore();
    const { user } = useUserStore();
    const [floatingMessage, setFloatingMessage] = useState("");

    const showMessage = (message) => {
        setFloatingMessage(message);
        setTimeout(() => setFloatingMessage(""), 3000);
    };

    // Load cart items on component mount
    useEffect(() => {
        getCartProducts();
    }, []);

    // ✅ Increase Quantity (Syncs with Backend)
    const increaseQuantity = async (id) => {
        const item = cartItems.find((e) => e.id === id);
        if (item) {
            const available = Number(item.available_quantity ?? 0);
            if (item.quantity >= available) {
                showMessage(`Only ${available} unit${available === 1 ? " is" : "s are"} available for ${item.name}.`);
                return;
            }
            try {
                await updateQuantity(id, item.quantity + 1);
            } catch (error) {
                showMessage(error.response?.data?.message || "Unable to update quantity.");
            }
        }
    };

    // ✅ Decrease Quantity (Minimum = 1, Syncs with Backend)
    const decreaseQuantity = async (id) => {
        const item = cartItems.find((e) => e.id === id);
        if (item && item.quantity > 1) {
            try {
                await updateQuantity(id, item.quantity - 1);
            } catch (error) {
                showMessage(error.response?.data?.message || "Unable to update quantity.");
            }
        }
    };

    const hasUnavailableItem = cartItems.some((item) =>
        Number(item.available_quantity ?? 0) <= 0 || item.quantity > Number(item.available_quantity ?? 0)
    );

    return (
        <div className='cartitems'>
            <div className="cartitems-format-main">
                <p>PRODUCT</p>
                <p>TITLE</p>
                <p>SIZE</p>
                <p>PRICE</p>
                <p>QUANTITY</p>
                <p>TOTAL</p>
                <p>REMOVE</p>
            </div>
            <hr />
            {cartItems.length > 0 ? cartItems.map((e) => (
                <div key={e.id}>
                    <div className="cartitems-format cartitems-format-main">
                        <img className='carticon-product-icon' src={e.image} alt={e.name} />
                        <p>{e.name}</p>
                        <p>{e.size}</p>
                        <p>₦{e.price}</p>
                        <div className="cartitems-stock-cell">
                            <div className="cartitems-quantity-wrapper">
                                <button className="cartitems-quantity-btn" onClick={() => decreaseQuantity(e.id)}>-</button>
                                <span className="cartitems-quantity">{e.quantity}</span>
                                <button
                                    className="cartitems-quantity-btn"
                                    onClick={() => increaseQuantity(e.id)}
                                    disabled={e.quantity >= Number(e.available_quantity ?? 0)}
                                >+</button>
                            </div>
                            {Number(e.available_quantity ?? 0) <= 0 ? (
                                <span className="cart-stock-warning">Out of stock</span>
                            ) : e.quantity > Number(e.available_quantity) ? (
                                <span className="cart-stock-warning">Only {e.available_quantity} available</span>
                            ) : Number(e.available_quantity) <= 2 ? (
                                <span className="cart-stock-warning">Only {e.available_quantity} left</span>
                            ) : null}
                        </div>
                        <p>₦{e.price * e.quantity}</p>
                        <img className='cartitems-remove-icon' src={remove_icon} onClick={() => removeFromCart(e.id)} alt="Remove" />
                    </div>
                    <hr />
                </div>
            )) : <p>Your cart is empty.</p>}
            <div className="cartitems-down">
                <div className="cartitems-total">
                    <h1>CART TOTAL</h1>
                    <div>
                        <div className="cartitems-total-item">
                            <p>Subtotal</p>
                            <p>₦{cartItems.reduce((total, item) => total + item.price * item.quantity, 0)}</p>
                        </div>
                        <hr />
                        <div className='cartitems-total-item'>
                            <p>Discount</p>
                            <p>0</p>
                        </div>
                        <hr />
                        <div className='cartitems-total-item'>
                            <h3>Total</h3>
                            <h3>₦{cartItems.reduce((total, item) => total + item.price * item.quantity, 0)}</h3>
                        </div>
                    </div>
                    <button
                        onClick={() => navigate("/Checkout")}
                        disabled={!cartItems.length || hasUnavailableItem}
                    >
                        {hasUnavailableItem ? "UPDATE CART TO CONTINUE" : "PROCEED TO CHECKOUT"}
                    </button>
                </div>
            </div>
            {floatingMessage && <div className="floating-message">{floatingMessage}</div>}
        </div>
    );
};

export default CartItems;
